import { AdditionalInfosProvider } from '../../../additional-infos/additional-infos-provider';
import { EventNarrative } from '../../../event-narrative';
import { FrTabContentWrapper } from './styled';
import { useOpenFrEventDetails } from '../../hooks/use-open-fr-event-details';
import { FR_EVENT_DETAILS_TABS } from '../../constants';

export default function FrNarrativeTab() {
    const openFrEventDetails = useOpenFrEventDetails();

    const onOpenFrEventDetails = (eventId: number) => {
        openFrEventDetails(eventId, FR_EVENT_DETAILS_TABS.EVENT_INFO);
    };

    return (
        <FrTabContentWrapper>
            <AdditionalInfosProvider>
                <EventNarrative isReadOnlyMode onOpenEvent={onOpenFrEventDetails} />
            </AdditionalInfosProvider>
        </FrTabContentWrapper>
    );
}
